import React from 'react';
import { Draggable } from 'react-beautiful-dnd';

export default function Trip(props) {
  const { data, assigned, count } = props;
  return (
    <Draggable draggableId={`trip-${data.id}`} index={data.id} type="TRIP">
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={`trip-label flex flex--space-between ${assigned && "trip-active"}`}
          style={{ minWidth: snapshot.isDragging ? "" : "100%", ...provided.draggableProps.style }}
        >
          <div className="position-relative trip-text">
            <div className="text-nowrap">
              <span>{data.nazwaWycieczki}</span>
            </div>
            {assigned && (
              <div className="trip-counter">
                <span>{count}</span>
              </div>
            )}
          </div>
        </div>
      )}
    </Draggable>
  );
}
